<template>
    <div class="bodyClass">
        <!--首页大框-->
        <div class="ph-top-box-ins">
             <mobileMenu />
            <!--菜单-->
            <!-- <div class="ph-logo-a4 mt10 pl10">
                <a href="#" class="dbi fl he40">
                    <img src="../../assets/mobile/images/logo2.png" width="" height="45" alt="" /></a>
                <a href="#" class="dbi fr he20 white pr10 mt14 mr12">
                    <span class="f14 txtsh">MENU</span>
                    <i class="fa fa-bars f18 txtsh"></i></a>
            </div> -->
            <!--菜单end-->
            <!-- <div class="ph-phone-mu" style="">
                <ul class="ph-ph-um-ul">
                    <li class="ph-ph-mu-li mt10"><a href="/mb/homeWebMb" class="db  f15 lp2 pl10 white txtsh">首页</a></li>
                    <li class="ph-ph-mu-li mt10"><a href="chanping-1.html" class="db white f15 lp2 pl10 txtsh">产品</a>
                        <div class="" style="">
                            <a class="db he34 ml50 ph-pml-a" href="chanping-4.html">视觉智能体</a>
                            <a class="db he34 ml50 ph-pml-a" href="chanping-3.html">新一代公共安全视觉智能体</a>
                            <a class="db he34 ml50 ph-pml-a" href="chanping-1.html">视觉大模型平台</a>
                            <a class="db he34 ml50 ph-pml-a" href="chanping-2.html">视觉大模型一体机</a>
                        </div>
                    </li>
                    <li class="ph-ph-mu-li mt10"><a href="jiejfa-1.html" class="db white txtsh f15 lp2 pl10">解决方案</a>
                        <div class="" style="">
                            <a class="db he34 ml50 ph-pml-a" href="jiejfa-1.html">公共安全行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="yijii-2.html">应急行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="chengguan-3.html">城管行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="jiaotong-4.html">交通行业解决方案</a>
                            <a class="db he34 ml50 ph-pml-a" href="qiyuegl-5.html">企业管理解决方案</a>
                        </div>
                    </li>
                    <li class="ph-ph-mu-li mt10"><a href="severHtml.html" class="db white txtsh f15 lp2 pl10">服务&生态</a>
                    </li>
                    <li class="ph-ph-mu-li mt10"><a href="gywmHtml.html" class="db white txtsh f15 lp2 pl10">关于我们</a>
                    </li>
                </ul>
            </div> -->
            <!--背景图-->
            <!-- <div class="ph-top-backgr">
                <div class="ph-top-box-ins-img"
                    style="background:url(../../assets/mobile/images/bana-9.jpg) center center no-repeat;background-size:cover;">
                </div>
                <div class="ph-top-box-ins-imga1"
                    style="background:url(../../assets/mobile/images/z8-ytj.png) center center no-repeat;background-size:cover;">
                </div>
            </div> -->
             <div class="ph-top-backgr ">
                <div class="ph-top-box-ins-img img1"></div>
                <div class="ph-top-box-ins-imga1 img2"></div>
            </div>
            <!--背景图end-->

            <!--首页大框end-->
        </div>
        <!--首页大框-->
        <!--内容大框-->
        <div class="ph-main pt24">
            <div class="w100 lh40 tc"> <span class="db f40 fb lp2 mt40">视觉智能体</span> 
                <span class="db f20  lp1 mt10 ph-col-gr">Visual Intelligent Agent</span> 
            </div>
            <div class="w90 jz mt40 lh30 f16">
                <p class="f20 fb mb30 tc">产品介绍</p>
                <p class="tl mb40">产品创新融合混合专家模式与思维链推理技术，构建多模态视觉智能分析智能体，通过文字描述的方式，分钟级创建算法并无需任何样本训练，实现对公共安全、应急管理、交通运输、水利水务、能源电力和企业管理等众多领域视觉场景中的特征、行为及事件的实时感知。产品可高效连接各类感知设备，也可与无人机、机器人、机器狗、智能穿戴设备等无缝对接，共同形成感知、研判、处置的业务闭环，全面提升客户风险管控与业务管理能力。</p>
                <p class="f20 fb mb30 tc">产品能力</p>
                <p class="f16 fb tl" style="color:rgb(255,0,0);">识万物、辨场景、擅推理</p>
                <p class="tl">该产品可精准识别预定义目标，还能依自然语言实现开放域场景自适应感知，大幅拓展视觉应用灵活性与覆盖范围。它通过自主创新技术架构，突破传统模型处理新兴目标、复杂场景及行为组合的瓶颈，全方位提升跨领域视觉任务效能，提供更高效精准感知方案。</p>
                <p class="f16 fb tl" style="color:rgb(255,0,0);">复杂场景算法零样本生成</p>
                <p class="tl">产品无需复杂样本训练，用户仅靠简洁文字描述，就能快速完成场景算法的增、删、改、査操作。同时，产品支持多解析器与多提示词，可通过多条件叠加灵活构建复杂算法逻辑，高效适配多样化场景需求。</p>
                <p class="f16 fb tl" style="color:rgb(255,0,0);">全量结构化分析</p>
                <p class="tl">产品可对人、车、设备等万物进行全维度结构化处理，不仅能提取基本特征，还可识别行为、环境等内容，且支持用户完全自定义、交互上可用文字对话检索信息，也能通过语音调度任务，检索维度涵盖时间、地点、行为等多条件。</p>
                <p class="f16 fb tl" style="color:rgb(255,0,0);">多种模式场景应用</p>
                <p class="tl">产品支持实时布控预警、现场指挥调度、智能终端联动三大核心应用模式，三者协同发力:可借实时监测预警防风险，凭现场视觉数据分析提升指挥效率，还能联通机器狗、机器人、无人机等带摄像头智能终端，实现具身智能场景应用。</p>
                <p class="f20 fb mb30 tc">产品优势</p>
                <p class="f16 tl fb" style="color:#4175cb">分钟级算法创建</p>
                <p class="tl">依托先进的自然语言处理和机器学习技术，用户仅需通过简洁文字描述，就能在分钟内完成复杂场景算法的定制。</p>
                <p class="f16 tl fb" style="color:#4175cb">小时级部署上线</p>
                <p class="tl">高效一站式部署，从算法创建完成到上线使用，仅需小时级时间使新算法能迅速投入实际业务场景。</p>
                <p class="f16 tl fb" style="color:#4175cb">零样本训练</p>
                <p class="tl">打破传统算法依赖大量样本训练的局限，在零样本数据的情况下，对新出现的目标或场景进行识别。</p>
                <p class="f16 tl fb" style="color:#4175cb">全生态支持</p>
                <p class="tl">底层架构支持国产化，实现基础软硬件国产化替代;终端可与多种智能终端无缝对接，构建一体化智能生态，满足复杂业务需求。</p>
                <p class="f16 tl fb" style="color:#4175cb">软硬一体化设计</p>
                <p class="tl">工业级机箱，支持多种部署模式，适应各类场景需求。内置模型管理平台，零代码完成任务配置与结果分析。</p>
                <p class="f20 fb mb30 tc">核心技术</p>
                <p class="f16 fb tl" style="color:rgb(255,0,0);">视觉原子识别</p>
                <p class="tl">多智能体融合通过异构专家系统协同实现多智能体融合通过智能体间的竞争-协作平衡，显著提升复杂场景下的综合认知性能。</p>
                <p class="f16 fb tl" style="color:rgb(255,0,0);">专家能力矩阵</p>
                <p class="tl">产品的专家能力矩阵通过模块化专家网络协同动态分配，构建兼具通用认知与专业深度的智能中枢，实现复杂场景下的高阶视觉分析与决策</p>
                <p class="f16 fb tl" style="color:rgb(255,0,0);">思维智慧推理</p>
                <p class="tl">基于多模态认知架构，通过深度语义理解与逻辑关联分析，实现高阶推理，理解隐含逻辑，完成复杂场景下的认知推断与策略生成。</p>
                <p class="f16 fb tl" style="color:rgb(255,0,0);">多智能体融合</p>
                <p class="tl">从海量数据中学习细粒度的视觉概念，建立物体、属性及局部特征的精准关联，支撑高精度任务，推动视觉智能迈向原子级感知新阶段</p>
                <p class="f20 fb mb30 tc">产品架构</p>
                <img src="../../assets/mobile/images/znyt_jgt.png" width="100%"/>
            </div>
            <div class="w100 lh40 tc"> <span class="db f40 fb lp2 mt40">视觉智能体一体机</span> 
                <span class="db f20  lp1 mt10 ph-col-gr">Visual Intelligent Agent All-in-One Machine</span> 
            </div>
            <div class="w90 jz mt40 lh30 f16">
                <p class="f20 fb mb30 tc">产品介绍</p>
                <p class="tl mb40">产品是集成了视觉智能体与高性能计算硬件的一站式智能设备专为复杂场景下的视觉分析任务设计。以视觉感知能力为核心，融合前沿科技实现对公共安全、应急管理、交通运输、水利水务、能源电力和企业管理等各领域视觉场景中的特征、行为及事件实时感知。产品精准洞察各类场景异常，为用户提供开箱即用的视觉分析服务，无需复杂部署，助力各行业智能化升级与跨越式发展。</p>
                <p class="f20 fb mb30 tc">典型场景</p>
                <img src="../../assets/mobile/images/dxcj_01.jpg" width="48%" class="mr12"/>
                <img src="../../assets/mobile/images/dxcj_02.jpg" width="48%"/>
                <img src="../../assets/mobile/images/dxcj_03.jpg" width="48%" class="mr12"/>
                <img src="../../assets/mobile/images/dxcj_04.jpg" width="48%"/>
                <img src="../../assets/mobile/images/dxcj_05.jpg" width="48%" class="mr12"/>
                <img src="../../assets/mobile/images/dxcj_06.jpg" width="48%"/>
                <img src="../../assets/mobile/images/dxcj_07.jpg" width="48%" class="mr12"/>
                <img src="../../assets/mobile/images/dxcj_08.jpg" width="48%"/>
                <p class="f20 fb mb30 tc">典型算法</p>
                <img src="../../assets/mobile/images/dxsf_01.jpg" width="48%" class="mr12"/>
                <img src="../../assets/mobile/images/dxsf_02.jpg" width="48%"/>
                <img src="../../assets/mobile/images/dxsf_03.jpg" width="48%" class="mr12"/>
                <img src="../../assets/mobile/images/dxsf_04.jpg" width="48%"/>
                <img src="../../assets/mobile/images/dxsf_05.jpg" width="48%" class="mr12"/>
                <img src="../../assets/mobile/images/dxsf_06.jpg" width="48%"/>
                <img src="../../assets/mobile/images/dxsf_07.jpg" width="48%" class="mr12"/>
                <img src="../../assets/mobile/images/dxsf_08.jpg" width="48%"/>
            </div>
        </div>
        <!--内容大框end-->
        <!--底宣-->

        <!--底宣end-->
        <!--底宣2-->
        <div class="ph-btto-b-a1 ov mt40">
            <div class="mt10 w95 jz pt10 pb10">
                <div class="tc"> <img src="../../assets/mobile/images/ying-28.jpg" width="76" height="76" alt="" class="dbi" /> </div>
                <ul class="w100 ov mt10">
                    <li class="tc">
                        <div class=" f16 white tc">上海谛视万象科技有限公司</div>
                        <div class="ov mt10 tc"><span class="dbi ph-btto-b-sp "><img src="../../assets/mobile/images/ico2_3.png" width="28" height="28" alt="" /></span><span class="dbi  ml10 mt4 f14 ph-col-gr3">联系电话：4007628008</span></div>
                    </li>
      
                </ul>
            </div>
        </div>
        <!--底宣2end-->
        <!--底宣3-->
        <div class="he90 tc ph-btto-c"> <span class="db ph-col-gr3  pt18">辽ICP备2025061615号</span>
            <span class="db ph-col-gr3  mt10">Copyright © 2004 - 2025 谛视万象版权所有</span>
        </div>
        <!--底宣3end-->
    </div>
</template>
<script setup>
import mobileMenu from './mobile-menu.vue';
</script>
<style scoped>
@import '@/assets/mobile/css/default.css';
@import '@/assets/mobile/css/font-awesome.min.css';
@import '@/assets/mobile/css/margin.css';
@import '@/assets/mobile/css/main.css';

.img1 {
    background: url(../../assets/mobile/images/bana-9.jpg) center center no-repeat;
    background-size: cover;
}

.img2 {
    background: url(../../assets/mobile/images/z8-ytj.png) center center no-repeat;
    background-size:300%,100%,cover;
}
</style>